import {
  Box,
  CircularProgress,
  Grid,
  IconButton,
  makeStyles,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip
} from "@material-ui/core";
import AssessmentIcon from "@material-ui/icons/Assessment";
import DeleteIcon from "@material-ui/icons/Delete";
import FileCopyIcon from '@material-ui/icons/FileCopy';
import SaveIcon from '@material-ui/icons/Save';
import ShareIcon from '@material-ui/icons/Share';
import _ from "lodash";
import moment from "moment";
import { useCallback, useEffect, useState } from "react";
import { LuArrowDown, LuArrowDownUp, LuArrowUp } from "react-icons/lu";
import SearchBar from "../../../common/Search";
import CustomTabs from "../../../common/Tabs";
import CustomAddModal from "../../../components/Common/CustomAddModal";
import CustomConfirmModal from "../../../components/Common/CustomConfirmModal";
import CustomPagination from "../../../components/Common/CustomPagination";
import ShareWithOrg from "../../../components/Common/ShareWithOrg";
import { getCurrentUserId, getCurrentUserOrganizationId, toastError, toastSuccess } from "../../../utils";
import * as actions from "../Calculator/actions";
import { createVesselCargoAnalysis } from "../VesselAnalysis/actions";
const useStyles = makeStyles({
  root: {
    width: "fit-content",
  },
});

const initialSearchType = {
  type: "",
  saveLabel: "",
  name: "",
  firstLoadPort: "",
  lastDischargePort: "",
  loadQuantity: "",
  createdDate: "",
};

function Voyages(props) {
  const { loader = false, setLoader = () => { } } = props;
  const classes = useStyles();

  const [value, setValue] = useState(1);
  const [open, setOpen] = useState(false);
  const [hasFetchedUser, setHasFetchedUser] = useState(false);
  const [hasFetchedOrg, setHasFetchedOrg] = useState(false);

  const [savedResults, setSavedResults] = useState([]);
  const [allSavedResults, setAllSavedResults] = useState([]);
  const [searchType, setSearchType] = useState({ ...initialSearchType });

  const [myFilters, setMyFilters] = useState({
    offset: 1,
    limit: 50,
    sortBy: "createdDate",
    sortDirection: "desc",
  });
  const [allFilters, setAllFilters] = useState({
    offset: 1,
    limit: 50,
    sortBy: "createdDate",
    sortDirection: "desc",
  });

  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState({});
  const [isShareConfirm, setShareConfirm] = useState(false);
  const [getSingleVoyagesData, setSingleVoyagesData] = useState("");

  const [shareLabel, setShareLabel] = useState("");
  const [isCopyConfirm, setCopyConfirm] = useState(false);
  const [duplicateItem, setDuplicateItem] = useState(null);

  // Estimation analysis state
  const [createAnalysisModal, setCreateAnalysisModal] = useState(false);
  const [createAnalysisVoyage, setCreateAnalysisVoyage] = useState(null);
  const [analysisName, setAnalysisName] = useState("");

  const organizationId = getCurrentUserOrganizationId();
  const [searchValue, setSearchValue] = useState("");
  const onSearchVessel = (search) => {
    getAllSavedResults(search);
    getAllOrgSavedResults(search);
  };
  const delaySearch = useCallback(
    _.debounce((data) => onSearchVessel(data), 500),
    []
  );
  const onSearchChange = (e) => {
    setSearchValue(e.target.value)
    delaySearch(e.target.value);
  }
  const [isInitialUserLoading, setIsInitialUserLoading] = useState(true);
  const [isInitialOrgLoading, setIsInitialOrgLoading] = useState(true);

  useEffect(() => {
    if (value === 1 && !hasFetchedUser) {
      getAllSavedResults();
    } else if (value === 2 && !hasFetchedOrg) {
      getAllOrgSavedResults();
    }
  }, [value]);

  const getAllSavedResults = async (search, filters) => {
    const currentFilters = filters || myFilters;
    if (!hasFetchedUser && (!savedResults || savedResults.length === 0)) {
      setIsInitialUserLoading(true);
    }
    await actions
      .allSavedResults({ userId: getCurrentUserId(), search: search, ...currentFilters })
      .then((res) => {
        setIsInitialUserLoading(false);
        setHasFetchedUser(true);
        setSavedResults(res?.data?.list || []);
        setMyFilters((prev) => ({
          ...prev,
          ...currentFilters,
          totalPages: res?.data?.totalItems,
          offset: res?.data?.currentPage,
          pageCount: res?.data?.totalPages,
          limit: res?.data?.perPage
        }))
      })
      .catch((err) => {
        setIsInitialUserLoading(false);
        setHasFetchedUser(true);
        toastError(err?.data?.message);
      });
  };

  const getAllOrgSavedResults = async (search, filters) => {
    const currentFilters = filters || allFilters;
    if (!hasFetchedOrg && (!allSavedResults || allSavedResults.length === 0)) {
      setIsInitialOrgLoading(true);
    }
    await actions
      .allSavedResults({ organizationId: organizationId, search: search, ...currentFilters })
      .then((res) => {
        setIsInitialOrgLoading(false);
        setHasFetchedOrg(true);
        setAllSavedResults(res?.data?.list || []);
        setAllFilters((prev) => ({
          ...prev,
          ...currentFilters,
          totalPages: res?.data?.totalItems,
          offset: res?.data?.currentPage,
          pageCount: res?.data?.totalPages,
          limit: res?.data?.perPage
        }))
      })
      .catch((err) => {
        setIsInitialOrgLoading(false);
        setHasFetchedOrg(true);
        toastError(err?.data?.message);
      });
  };

  const handleSortClick = (sortKey, isAll) => {
    const currentFilters = isAll ? allFilters : myFilters;
    let newSortDirection = "asc";

    if (currentFilters.sortBy === sortKey) {
      if (currentFilters.sortDirection === "asc") newSortDirection = "desc";
      else if (currentFilters.sortDirection === "desc") {
        newSortDirection = sortKey === "createdDate" ? "asc" : "";
      }
    } else {
      newSortDirection = sortKey === "createdDate" ? "desc" : "asc";
    }

    let apiFilters = { ...currentFilters, sortBy: sortKey, sortDirection: newSortDirection, offset: 1 };
    if (!newSortDirection) {
      apiFilters.sortBy = "createdDate";
      apiFilters.sortDirection = "desc";
    }

    if (isAll) {
      getAllOrgSavedResults(searchValue, apiFilters);
    } else {
      getAllSavedResults(searchValue, apiFilters);
    }
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
    setSearchType({ ...initialSearchType });
  };

  const onClickDeleteSavedFleet = (id) => {
    setDeleteId(id);
    setDeleteModal(true);
  };

  const onShareOrgClick = (item) => {
    setShareConfirm(!isShareConfirm)
    setSingleVoyagesData(item ? item : "")
    setShareLabel("")
  }
  const onCopyClick = (item) => {
    setCopyConfirm(!isCopyConfirm)
    setSingleVoyagesData(item ? item : "")
    setShareLabel("")
  }

  const onShareOrgSaveClick = async () => {
    if (!shareLabel || !getSingleVoyagesData || !organizationId) return
    try {
      setLoader(true);
      const res = await actions.saveResultById(getSingleVoyagesData._id);
      const fullData = res.data;
      let { _id, ...data } = fullData;
      data.access = "public"
      data.organizationId = organizationId
      data.name = shareLabel
      await actions.saveCalculatedCostResult(data);

      setShareConfirm(false)
      setShareLabel("")
      setLoader(false);
      getAllOrgSavedResults()
    } catch (e) {
      setLoader(false);
      toastError(e?.data?.message || "Error sharing result");
    }
  }

  const onCopySaveClick = async () => {
    if (!shareLabel || !getSingleVoyagesData || !organizationId) return
    try {
      setLoader(true);
      const res = await actions.saveResultById(getSingleVoyagesData._id);
      const fullData = res.data;
      let { _id, ...data } = fullData;
      data.access = "private"
      data.organizationId = organizationId
      data.name = shareLabel
      await actions.saveCalculatedCostResult(data);

      setCopyConfirm(false)
      setShareLabel("")
      setLoader(false);
      getAllSavedResults()
    } catch (e) {
      setLoader(false);
      toastError(e?.data?.message || "Error copying result");
    }
  }

  const onDuplicateClick = async (item) => {
    if (!item || !organizationId) return
    try {
      setLoader(true);
      const res = await actions.saveResultById(item._id);
      const fullData = res.data;
      let { _id, ...data } = fullData;
      data.access = "private"
      data.organizationId = organizationId
      data.name = item.name ? `${item.name}-copy` : "copy"
      await actions.saveCalculatedCostResult(data);
      setLoader(false);
      toastSuccess("Duplicate created successfully");
      if (value === 1) getAllSavedResults();
      else getAllOrgSavedResults();
    } catch (e) {
      setLoader(false);
      toastError(e?.data?.message || "Failed to create duplicate");
    }
  }

  const onClickCreateVesselAnalysis = (item) => {
    setCreateAnalysisVoyage(item);
    setAnalysisName("");
    setCreateAnalysisModal(true);
  };

  const onSubmitCreateVesselAnalysis = async () => {
    if (!analysisName.trim()) return toastError("Please enter an analysis name");
    if (!createAnalysisVoyage) return;
    try {
      setLoader(true);
      const res = await actions.saveResultById(createAnalysisVoyage._id);
      const fullData = res.data;
      const { _id, ...baseData } = fullData;
      const createRes = await createVesselCargoAnalysis({
        ...baseData,
        name: analysisName.trim(),
        vesselId: createAnalysisVoyage._id,
      });
      setLoader(false);
      const newAnalysis = createRes?.data;
      setCreateAnalysisModal(false);
      setAnalysisName("");
      if (newAnalysis?._id) {
        window.open(`/estimation-analysis/estimation/${newAnalysis._id}`, "_blank");
      }
    } catch (err) {
      setLoader(false);
      toastError(err?.data?.message || "Failed to create Estimation analysis");
    }
  };

  const onChangeSearchType = (e, key = "") => {
    let { name = "", value = "" } = e.target || {};
    if (!value) name = "";
    let updatedSearchType = { ...searchType };
    if (name === "loadQuantity") {
      let valueSplit = updatedSearchType[name].split(",");
      let startValue = valueSplit[0] || "";
      let endValue = valueSplit[1] || "";
      if (key === "start") startValue = value;
      else endValue = value;
      value = `${startValue},${endValue}`;
    } else if (name === "createdDate") {
      let valueSplit = updatedSearchType[name].split(",");
      let startValue = valueSplit[0] || "";
      let endValue = valueSplit[1] || "";
      if (key === "start") startValue = moment(value).valueOf();
      else endValue = moment(value).valueOf();
      value = `${startValue},${endValue}`;
    }
    setSearchType({ ...initialSearchType, type: name, [name]: value });
  };

  const onClickSubmitSearch = async () => {
    if (searchType.type) {
      let searchRequest = actions.allVoyageResultsByChar;
      if (value !== 1) searchRequest = () => { };
      await searchRequest({
        searchParam: searchType[searchType.type],
        type: searchType.type,
        offset: 10,
      }).then((res) => {
        setSavedResults((Array.isArray(res) && res) || []);
      });
    } else {
      let searchRequest = actions.allSavedResults;
      if (value !== 1) searchRequest = actions.allSavedResults;
      await searchRequest().then((res) => {
        setSavedResults(
          (res?.data?.list &&
            Array.isArray(res?.data?.list) &&
            res?.data?.list) ||
          []
        );
      });
    }
  };

  const onChangeMyPagination = (type = "") => {
    let newMyFilters = {};
    if (type === "inc") {
      newMyFilters = { ...myFilters, offset: myFilters.offset + 1 };
    } else if (type === "first") {
      newMyFilters = { ...myFilters, offset: 1 };
    } else {
      if (myFilters.offset === 1) return;
      newMyFilters = { ...myFilters, offset: myFilters.offset - 1 };
    }
    getAllSavedResults(searchValue, { ...myFilters, offset: newMyFilters.offset });
  };

  const onChangeAllPagination = (type = "") => {
    let newAllFilters = {};
    if (type === "inc") {
      newAllFilters = { ...allFilters, offset: allFilters.offset + 1 };
    } else if (type === "first") {
      newAllFilters = { ...allFilters, offset: 1 };
    } else {
      if (allFilters.offset === 1) return;
      newAllFilters = { ...allFilters, offset: allFilters.offset - 1 };
    }
    getAllOrgSavedResults(searchValue, { ...allFilters, offset: newAllFilters.offset });
  };

  const onClickClearMyVoyages = async () => {
    await getAllSavedResults();
    setSearchType({ ...initialSearchType });
  };

  const onDeleteVoyages = () => {
    actions
      .deleteSavedResultById(deleteId)
      .then((res) => {
        toastSuccess("Result deleted successfully");
        setDeleteModal(false);
        setDeleteId("");
        getAllSavedResults();
      })
      .catch((err) => {
        toastError();
      });
  };

  const loadSliderValue = String(searchType.loadQuantity).split(",");
  const createdDateValue = String(searchType.createdDate).split(",");
  const handleDateRangeChange = async (newDateRange) => {
    const { startDate, endDate } = newDateRange;

    // Ensure dates are in ISO string format
    const formattedStartDate = startDate?.toISOString() || '';
    const formattedEndDate = endDate?.toISOString() || '';

    if (value === 2) {
      const { data } = await actions.allSavedResults({
        organizationId: organizationId,
        startDate: formattedStartDate,
        endDate: formattedEndDate
      });
      setAllSavedResults(data?.list);
    }
    else {
      const { data } = await actions.allSavedResults({
        userId: getCurrentUserId(),
        startDate: formattedStartDate,
        endDate: formattedEndDate
      });
      setSavedResults(data?.list);
    }
  };

  const tabs = [
    { label: "My Voyages", key: 1, tooltip: "Displays voyages added by you" },
    { label: "All Voyages", key: 2, tooltip: "View voyages shared with your organization. Copy any voyage to your personal list" },
  ];

  return (
    <Grid container alignContent="flex-start" className="min-h-[calc(100vh-106px)]">
      <Grid item xs={12}>
        <Box
          display="flex"
          alignItems="center"
          position="relative"
          width="100%"
        >
          <Box>
            <CustomTabs tabs={tabs} active={value} onChange={handleChange} />
          </Box>

          <Box
            position="absolute"
            left="50%"
            sx={{
              transform: "translateX(-50%)",
              display: { xs: "none", md: "block" }, // Desktop view
            }}
          >
            <div className="desktop-searchbar">
              <SearchBar
                onDateRangeChange={handleDateRangeChange}
                placeholder={"Search with Voyage Label or Voyage Name..."}
                setSearchValue={onSearchChange}
                searchValue={searchValue}
              />
            </div>
          </Box>
        </Box>

        {/* Mobile search bar */}
        <Box
          className="md:hidden"
          display="flex"
          justifyContent="center"
          mt={2}
        >
          <div className="w-full"><SearchBar
            isMobile
            onDateRangeChange={handleDateRangeChange}
            placeholder={"Search with Voyage Label or Voyage Name..."}
            setSearchValue={onSearchChange}
            searchValue={searchValue}
          /></div>
        </Box>
      </Grid>

      <Grid item xs={12}></Grid>

      <Grid item xs={12}>
        {value === 1 ? (
          <Box pt={2}>
            <TableContainer component={Paper} style={{ minHeight: (loader || !savedResults?.length) ? "500px" : "auto", overflow: loader ? "hidden" : "auto" }}>
              {myFilters?.totalPages > myFilters?.limit && (
                <CustomPagination
                  onChangePagination={onChangeMyPagination}
                  filters={myFilters}
                  totalPage={myFilters?.totalPages}
                />
              )}
              <Table className="universal-table fit-content-mobile">
                <TableHead>
                  <TableRow>
                    <TableCell>No.</TableCell>
                    <TableCell>Voyage Label</TableCell>
                    <TableCell>Vessel Name</TableCell>
                    <TableCell>Opening Port</TableCell>
                    <TableCell>Name</TableCell>
                    <TableCell>First Load Port</TableCell>
                    <TableCell>Last Discharge Port</TableCell>
                    <TableCell>Load Qty</TableCell>
                    <TableCell style={{ cursor: "pointer" }} onClick={() => handleSortClick("createdDate", false)}>
                      <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                        Created on
                        <div style={{ color: myFilters.sortBy === "createdDate" ? "#fff" : "rgba(255,255,255,0.4)", display: "flex", alignItems: "center" }}>
                          {myFilters.sortBy === "createdDate" && myFilters.sortDirection === "desc" ? <LuArrowDown size={14} /> : myFilters.sortBy === "createdDate" && myFilters.sortDirection === "asc" ? <LuArrowUp size={14} /> : <LuArrowDownUp size={14} />}
                        </div>
                      </div>
                    </TableCell>
                    <TableCell>Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {/* <TableRow className="searchable-tablerow">
                    <TableCell>
                      {searchType.type ? (
                        <CancelIcon
                          style={{ color: "#009EF7" }}
                          onClick={onClickClearMyVoyages}
                        />
                      ) : null}
                    </TableCell>
                    <TableCell>
                      <input
                        name="saveLabel"
                        value={searchType.saveLabel}
                        onChange={onChangeSearchType}
                      />
                    </TableCell>
                    <TableCell>
                      <input
                        name="name"
                        value={searchType.name}
                        onChange={onChangeSearchType}
                      />
                    </TableCell>
                    <TableCell>
                      <input
                        name="name"
                        value={searchType.name}
                        onChange={onChangeSearchType}
                      />
                    </TableCell>
                    <TableCell>
                      <input
                        name="name"
                        value={searchType.name}
                        onChange={onChangeSearchType}
                      />
                    </TableCell>
                    <TableCell>
                      <input
                        name="firstLoadPort"
                        value={searchType.firstLoadPort}
                        onChange={onChangeSearchType}
                      />
                    </TableCell>
                    <TableCell>
                      <input
                        name="lastDischargePort"
                        value={searchType.lastDischargePort}
                        onChange={onChangeSearchType}
                      />
                    </TableCell>
                    <TableCell>
                      <div className="range-load-quantity">
                        <input
                          type="number"
                          name="loadQuantity"
                          value={loadSliderValue[0] || ""}
                          onChange={(e) => onChangeSearchType(e, "start")}
                        />
                        <input
                          type="number"
                          name="loadQuantity"
                          value={loadSliderValue[1] || ""}
                          onChange={(e) => onChangeSearchType(e, "end")}
                        />
                      </div>
                    </TableCell>
                    <TableCell>
                      <MuiPickersUtilsProvider utils={MomentUtils}>
                        <DatePicker
                          autoOk
                          fullWidth
                          variant="inline"
                          inputVariant="outlined"
                          format="DD/MMM/yyyy"
                          className="small-date-picker"
                          placeholder="Start"
                          size="small"
                          name="createdDate"
                          clearable
                          value={
                            (createdDateValue &&
                              createdDateValue[0] &&
                              Number(createdDateValue[0])) ||
                            null
                          }
                          onChange={(date) =>
                            onChangeSearchType(
                              { target: { name: "createdDate", value: date } },
                              "start"
                            )
                          }
                        />
                      </MuiPickersUtilsProvider>
                      <MuiPickersUtilsProvider utils={MomentUtils}>
                        <DatePicker
                          autoOk
                          fullWidth
                          variant="inline"
                          inputVariant="outlined"
                          format="DD/MMM/yyyy"
                          className="small-date-picker"
                          style={{ marginLeft: 10 }}
                          placeholder="End"
                          size="small"
                          clearable
                          name="createdDate"
                          value={
                            (createdDateValue &&
                              createdDateValue[1] &&
                              Number(createdDateValue[1])) ||
                            null
                          }
                          onChange={(date) =>
                            onChangeSearchType(
                              { target: { name: "createdDate", value: date } },
                              "end"
                            )
                          }
                        />
                      </MuiPickersUtilsProvider>
                    </TableCell>
                    <TableCell>
                      <button onClick={onClickSubmitSearch}>Search</button>
                    </TableCell>
                  </TableRow> */}
                  {isInitialUserLoading && (!Array.isArray(savedResults) || !savedResults.length) ? (
                    <TableRow>
                      <TableCell colSpan={10} align="center" className="!bg-white">
                        <Box display="flex" justifyContent="center" alignItems="center" height="440px">
                          {savedResults?.length > 0 && <CircularProgress />}
                        </Box>
                      </TableCell>
                    </TableRow>
                  ) : Array.isArray(savedResults) && savedResults.length ? (
                    savedResults.map((item, index) => {
                      return (
                        <TableRow
                          key={index}
                          className="hover:bg-gray-50 cursor-pointer"
                          onDoubleClick={() => window.open(`/saved/${item._id}`, "_blank")}
                        >
                          <TableCell>{(myFilters.offset - 1) * myFilters.limit + index + 1}</TableCell>
                          <TableCell>
                            <a
                              style={{ color: "blue" }}
                              href={`/saved/${item._id}`}
                              target="_blank"
                              rel="noreferrer"
                            >
                              {item.name || ""}
                            </a>
                          </TableCell>
                          <TableCell>
                            {(() => {
                              let vName = "";
                              if (typeof item?.vessel === 'string') {
                                try { vName = JSON.parse(item.vessel)?.vesselName || JSON.parse(item.vessel)?.name; } catch (e) { vName = item.vessel; }
                              } else if (item?.vessel) {
                                vName = item.vessel.vesselName || item.vessel.name;
                              }
                              return vName || "";
                            })()}
                          </TableCell>
                          <TableCell>
                            {(() => {
                              let vPort = "";
                              if (typeof item?.vessel === 'string') {
                                try { vPort = JSON.parse(item.vessel)?.port; } catch (e) { vPort = ""; }
                              } else if (item?.vessel) {
                                vPort = item.vessel.port;
                              }
                              return vPort || "-";
                            })()}
                          </TableCell>
                          <TableCell>{item.name || ""}</TableCell>
                          <TableCell>{item.firstLoadPort || item?.clientQuery?.cargoList?.[0]?.port || ""}</TableCell>
                          <TableCell>{item.lastDischargePort || item?.clientQuery?.cargoList?.[item?.clientQuery?.cargoList?.length - 1]?.port || ""}</TableCell>
                          <TableCell>
                            {item.loadQuantity || item?.clientQuery?.cargoList?.reduce((acc, curr) => acc + (Number(curr?.cargoQuantity) || Number(curr?.cargoQty) || 0), 0) || 0}
                          </TableCell>
                          <TableCell>
                            {item.createdDate
                              ? moment(item.createdDate).format("DD/MMM/yyyy")
                              : ""}
                          </TableCell>
                          <TableCell>
                            <div className="flex items-center gap-1 justify-start">
                              <Tooltip title="Create Estimation analysis">
                                <IconButton size="small" onClick={() => onClickCreateVesselAnalysis(item)}>
                                  <AssessmentIcon color="primary" fontSize="small" />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title="Share with your Team">
                                <IconButton size="small" onClick={() => onShareOrgClick(item)}>
                                  <ShareIcon color="primary" fontSize="small" />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title="Create Duplicate">
                                <IconButton size="small" onClick={() => setDuplicateItem(item)}>
                                  <FileCopyIcon color="primary" fontSize="small" />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title="Delete">
                                <IconButton size="small" onClick={() => onClickDeleteSavedFleet(item._id)}>
                                  <DeleteIcon color="secondary" fontSize="small" />
                                </IconButton>
                              </Tooltip>
                            </div>
                          </TableCell>
                        </TableRow>
                      );
                    })
                  ) : hasFetchedUser ? (
                    <TableRow>
                      <TableCell colSpan={10} align="center" className="!bg-white">
                        <Box display="flex" justifyContent="center" alignItems="center" height="440px">
                          No Voyages Found.
                        </Box>
                      </TableCell>
                    </TableRow>
                  ) : null}
                </TableBody>
              </Table>
              {myFilters?.totalPages > myFilters?.limit && (
                <CustomPagination
                  onChangePagination={onChangeMyPagination}
                  filters={myFilters}
                  totalPage={myFilters?.totalPages}
                />
              )}
            </TableContainer>
          </Box>
        ) : (
          <Box pt={2}>
            <TableContainer component={Paper} style={{ minHeight: (!allSavedResults?.length && isInitialOrgLoading) ? "500px" : "auto" }}>
              {allFilters?.totalPages > allFilters?.limit && (
                <CustomPagination
                  onChangePagination={onChangeAllPagination}
                  filters={allFilters}
                  totalPage={allFilters?.totalPages}
                />
              )}
              <Table className="universal-table fit-content-mobile">
                <TableHead>
                  <TableRow>
                    <TableCell>No.</TableCell>
                    <TableCell>Name</TableCell>
                    <TableCell>Vessel Name</TableCell>
                    {/* <TableCell>Name</TableCell> */}
                    <TableCell>First Load Port</TableCell>
                    <TableCell>Last Discharge Port</TableCell>
                    <TableCell>Load Qty</TableCell>
                    <TableCell style={{ cursor: "pointer" }} onClick={() => handleSortClick("createdDate", true)}>
                      <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                        Created on
                        <div style={{ color: allFilters.sortBy === "createdDate" ? "#fff" : "rgba(255,255,255,0.4)", display: "flex", alignItems: "center" }}>
                          {allFilters.sortBy === "createdDate" && allFilters.sortDirection === "desc" ? <LuArrowDown size={14} /> : allFilters.sortBy === "createdDate" && allFilters.sortDirection === "asc" ? <LuArrowUp size={14} /> : <LuArrowDownUp size={14} />}
                        </div>
                      </div>
                    </TableCell>
                    <TableCell>Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {isInitialOrgLoading && (!Array.isArray(allSavedResults) || !allSavedResults.length) ? (
                    <TableRow>
                      <TableCell colSpan={8} align="center" className="!bg-white">
                        <Box display="flex" justifyContent="center" alignItems="center" height="440px">
                          {allSavedResults?.length > 0 && <CircularProgress />}
                        </Box>
                      </TableCell>
                    </TableRow>
                  ) : Array.isArray(allSavedResults) && allSavedResults.length ? (
                    allSavedResults.map((item, index) => {
                      return (
                        <TableRow
                          key={index}
                          className="hover:bg-gray-50 cursor-pointer"
                          onDoubleClick={() => window.open(`/saved/${item._id}`, "_blank")}
                        >
                          <TableCell>{(allFilters.offset - 1) * allFilters.limit + index + 1}</TableCell>
                          <TableCell>
                            {" "}
                            <a
                              style={{ color: "blue" }}
                              href={`/saved/${item._id}`}
                              target="_blank"
                              rel="noreferrer"
                            >
                              {item.name || ""}
                            </a>
                          </TableCell>
                          <TableCell>
                            {(() => {
                              let vName = "";
                              if (typeof item?.vessel === 'string') {
                                try { vName = JSON.parse(item.vessel)?.vesselName || JSON.parse(item.vessel)?.name; } catch (e) { vName = item.vessel; }
                              } else if (item?.vessel) {
                                vName = item.vessel.vesselName || item.vessel.name;
                              }
                              return vName || "";
                            })()}
                          </TableCell>
                          <TableCell>{item.firstLoadPort || item?.clientQuery?.cargoList?.[0]?.port || ""}</TableCell>
                          <TableCell>{item.lastDischargePort || item?.clientQuery?.cargoList?.[item?.clientQuery?.cargoList?.length - 1]?.port || ""}</TableCell>
                          <TableCell>
                            {item.loadQuantity || item?.clientQuery?.cargoList?.reduce((acc, curr) => acc + (Number(curr?.cargoQuantity) || Number(curr?.cargoQty) || 0), 0) || 0}
                          </TableCell>
                          <TableCell>
                            {item.createdDate
                              ? moment(item.createdDate).format("DD/MMM/yyyy")
                              : ""}
                          </TableCell>
                          <TableCell>
                            <>
                              <span className="pending-steper validate-icon-vessel-manager">
                                <SaveIcon
                                  color="primary"
                                  onClick={() => onCopyClick(item)}
                                />
                              </span>
                              <div className="tooltip-notification-vessel-manager">
                                <p>Copy to My Voyages</p>
                              </div>
                            </>

                            {/* <VisibilityIcon color="primary" onClick={() => { onClickEditQuery(item); setIsDetailView(true) }} /> */}
                          </TableCell>
                        </TableRow>
                      );
                    })
                  ) : hasFetchedOrg ? (
                    <TableRow>
                      <TableCell colSpan={10} align="center" className="!bg-white">
                        <Box display="flex" justifyContent="center" alignItems="center" height="440px">
                          No Voyages Found.
                        </Box>
                      </TableCell>
                    </TableRow>
                  ) : null}
                </TableBody>
              </Table>
              {allFilters?.totalPages > allFilters?.limit && (
                <CustomPagination
                  onChangePagination={onChangeAllPagination}
                  filters={allFilters}
                  totalPage={allFilters?.totalPages}
                />
              )}
            </TableContainer>
          </Box>
        )}
      </Grid>

      <CustomConfirmModal
        open={!!duplicateItem}
        handleClose={() => setDuplicateItem(null)}
        message={`Create a duplicate of "${duplicateItem?.name || "this voyage"}"? It will be added to My Voyages as "-copy".`}
        onSubmitConfirm={() => {
          const item = duplicateItem;
          setDuplicateItem(null);
          onDuplicateClick(item);
        }}
        type="info"
        confirmText="DUPLICATE"
        cancelText="Cancel"
      />

      <CustomConfirmModal
        open={deleteModal}
        handleClose={() => setDeleteModal(false)}
        message="Are you sure you want to delete this voyage?"
        onSubmitConfirm={onDeleteVoyages}
        type="warning"
        confirmText="DELETE"
        cancelText="Cancel"
        note="This action cannot be undone."
      />

      <CustomAddModal
        open={isShareConfirm}
        handleClose={onShareOrgClick}
        onSubmitConfirm={onShareOrgSaveClick}
        maxWidth="xs"
        saveLabel="Share"
        title="Share with Team"
      >
        <ShareWithOrg
          value={shareLabel}
          onChange={(e) => setShareLabel(e.target.value)}
          placeholder="Enter Voyages name*"
          label="Team copy name"
          guidanceTitle="Share this voyage"
          guidance="Create a team copy of this saved voyage. Your team can find it in All Voyages."
        />
      </CustomAddModal>

      <CustomAddModal
        open={isCopyConfirm}
        handleClose={onCopyClick}
        onSubmitConfirm={onCopySaveClick}
        maxWidth="xs"
        saveLabel="Create"
        title="Copy to My Voyages"
      >
        <ShareWithOrg
          value={shareLabel}
          onChange={(e) => setShareLabel(e.target.value)}
          placeholder="Enter Voyages name*"
          label="My copy name"
          guidanceTitle="Copy this voyage"
          guidance="Create a separate personal copy of this shared voyage. Find it in My Voyages."
        />
      </CustomAddModal>

      {/* Create Estimation analysis Modal */}
      <CustomAddModal
        open={createAnalysisModal}
        handleClose={() => setCreateAnalysisModal(false)}
        onSubmitConfirm={onSubmitCreateVesselAnalysis}
        maxWidth="xs"
        saveLabel="Create"
        title="Create Estimation analysis"
      >
        <ShareWithOrg
          value={analysisName}
          onChange={(e) => setAnalysisName(e.target.value)}
          placeholder="Enter Analysis Name*"
          label="Analysis name"
          guidanceTitle="Create an estimation analysis"
          guidance="Create an Estimation analysis from this saved voyage. It opens in a new tab; find it later in Estimation Analysis → My Estimation analysis."
        />
      </CustomAddModal>
    </Grid>
  );
}

export default Voyages;
